import { RootState } from '@store';

export const selectModelSeriesMapping = (state: RootState) => {
  return state.modelSeriesMapping?.modelSeriesMapping;
};
